var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    'shadowed-product-container': _vm.shadowed,
  }},[_c('div',{class:{
      'white-bg': !_vm.transparent,
    }},_vm._l((_vm.slots),function(slot,index){return _c('section',{key:index},[_vm._t(slot)],2)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }